import { ArrowRight, Mail, Calendar } from "lucide-react";
import { SlideFrame, SlideHeader, Reveal } from "@/components/presentation/slides/SlideFrame";
import { Button } from "@/components/primitives/Button";

/**
 * 10 · ClosingSlide
 *
 * Final beat of the presentation. Strong headline, calm narrative, primary
 * call-to-action, and a quiet block of contact information. An optional
 * `onEnterExplore` handler exposes the transition into Explore Mode, so the
 * closing can hand off directly without going through the ending screen.
 */
export const ClosingSlide = ({
  eyebrow = "Closing",
  title = "And that's the work.",
  narrative = "A final, quiet sentence of conviction. The floor opens.",
  ctaLabel = "Get in touch",
  onCta,
  contact = {
    email: "investors@haevn.placeholder",
    schedule: "Schedule a working session",
  },
  exploreLabel = "Or explore the portal",
  onEnterExplore,
}) => {
  return (
    <SlideFrame testId="slide-closing" width="narrow">
      <SlideHeader
        eyebrow={eyebrow}
        title={title}
        lede={narrative}
        size="xl"
        align="center"
      />

      <Reveal delay={3} className="flex flex-wrap items-center justify-center gap-3">
        <Button
          variant="primary"
          size="lg"
          onClick={onCta}
          iconRight={<ArrowRight className="h-4 w-4" />}
          data-testid="closing-cta-button"
        >
          {ctaLabel}
        </Button>
        {onEnterExplore && (
          <Button
            variant="secondary"
            size="lg"
            onClick={onEnterExplore}
            data-testid="closing-explore-button"
          >
            {exploreLabel}
          </Button>
        )}
      </Reveal>

      <Reveal delay={4}>
        <div
          data-testid="closing-contact"
          className="mx-auto grid w-full max-w-md grid-cols-1 gap-3 rounded-xl border border-border bg-card p-5 sm:grid-cols-2"
        >
          <div className="flex items-center gap-3" data-testid="closing-contact-email">
            <Mail className="h-3.5 w-3.5 text-muted-foreground" aria-hidden="true" />
            <span className="font-mono text-xs text-foreground">{contact.email}</span>
          </div>
          <div className="flex items-center gap-3" data-testid="closing-contact-schedule">
            <Calendar className="h-3.5 w-3.5 text-muted-foreground" aria-hidden="true" />
            <span className="text-xs text-foreground">{contact.schedule}</span>
          </div>
        </div>
      </Reveal>
    </SlideFrame>
  );
};

export default ClosingSlide;
